import { AUTH_SPECIAL_CHARACTERS } from "@/modules/auth/authUtils"
import type { Language } from "@/modules/language/utils/languageUtils"
import { word } from "@modules/core/utils/i18n"
import { z } from "zod"

export type SignUpFields = {
  email: string
  password: string
  isTandCChecked: boolean
  isCharterChecked: boolean
}

export const signUpFieldsSchema = (_language: Language) =>
  z.object({
    email: z.email(word("auth.signup.form.mail_invalid")),
    password: z
      .string()
      .min(8, word("auth.signup.form.info_valid_password"))
      .max(256, word("auth.signup.form.info_valid_password"))
      .refine(
        (value) => AUTH_SPECIAL_CHARACTERS.some((c) => value.includes(c)),
        `${word("auth.signup.form.info_valid_password")} ${word("auth.signup.form.pasword_special_character_list")}: ${AUTH_SPECIAL_CHARACTERS.join(" ")}`,
      )
      .regex(
        /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9\S$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
        `${word("auth.signup.form.password_invalid")}. ${word("auth.signup.form.pasword_special_character_list")}: ${AUTH_SPECIAL_CHARACTERS.join(" ")}`,
      ),
    isTandCChecked: z.literal(true),
    isCharterChecked: z.literal(true),
  })

export type LoginFields = {
  email: string
  password: string
}

export const loginFieldsSchema = (_language: Language) =>
  z.object({
    email: z.email(word("auth.signup.form.mail_invalid")),
    password: z.string(),
  })

export type SendCodeFields = {
  email: string
}

export const sendCodeFieldsSchema = (_language: Language) =>
  z.object({
    email: z.email(word("auth.signup.form.mail_invalid")),
  })

export type ResetPasswordFields = {
  code: string
  newPassword: string
}

const CONFIRM_CODE_LENGTH = 6

export const resetPasswordFieldsSchema = (_language: Language) =>
  z.object({
    code: z.string().length(CONFIRM_CODE_LENGTH, word("auth.check_signup.form.invalid_code")),
    newPassword: z
      .string()
      .min(8, word("auth.signup.form.info_valid_password"))
      .max(256, word("auth.signup.form.info_valid_password"))
      .refine(
        (value) => AUTH_SPECIAL_CHARACTERS.some((c) => value.includes(c)),
        `${word("auth.signup.form.info_valid_password")} ${word("auth.signup.form.pasword_special_character_list")}: ${AUTH_SPECIAL_CHARACTERS.join(" ")}`,
      )
      .regex(
        /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9\S$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
        `${word("auth.signup.form.password_invalid")}. ${word("auth.signup.form.pasword_special_character_list")}: ${AUTH_SPECIAL_CHARACTERS.join(" ")}`,
      ),
  })

export type ConfirmEmailFields = {
  code: string
}

export const confirmEmailFieldsSchema = (_language: Language) =>
  z.object({
    code: z.string().length(CONFIRM_CODE_LENGTH, word("auth.check_signup.form.invalid_code")),
  })
